import { render } from "./mobileVideo.vue?vue&type=template&id=76bbd006&scoped=true"
import script from "./mobileVideo.vue?vue&type=script&lang=js"
export * from "./mobileVideo.vue?vue&type=script&lang=js"

import "./mobileVideo.vue?vue&type=style&index=0&id=76bbd006&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bbd006"]])

export default __exports__